import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./hooks/useAuth";
import { SiteProvider } from "./context/SiteContext";
import { SiteConfigProvider } from "./context/SiteConfigContext";
import { TemplateProvider } from "./context/TemplateContext";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <SiteProvider>
        <SiteConfigProvider>
          <TemplateProvider>
            <AuthProvider>
              <BrowserRouter basename={__BASE_PATH__}>
                <AppRoutes />
              </BrowserRouter>
            </AuthProvider>
          </TemplateProvider>
        </SiteConfigProvider>
      </SiteProvider>
    </I18nextProvider>
  );
}

export default App;
